<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useLayout } from '@/layout/composables/layout';
import { useRouter } from 'vue-router';
import useAppStore from '../service/app/AppService';
import UserMenu from '@/components/Profile/UserMenu.vue';
import UserStore from '@/service/auth/UserService';
// import Notification from '../components/Profile/Notification.vue';

const { changeThemeSettings, layoutConfig, onMenuToggle } = useLayout();

const UserService = UserStore();
const outsideClickListener = ref(null);
const topbarMenuActive = ref(false);
const router = useRouter();
const userMenuOverlay = ref();
const notification_visible = ref(false);

onMounted(() => {
    bindOutsideClickListener();
});

onBeforeUnmount(() => {
    unbindOutsideClickListener();
});

const themeIcon = computed(() => {
    return layoutConfig.darkTheme.value ? 'sun' : 'moon';
});

const logoUrl = computed(() => {
    return `/layout/images/${layoutConfig.darkTheme.value ? 'lca-w' : 'lca-b'}.png`;
});

const onTopBarMenuButton = (event, item = null) => {
    if (item == 'profile') {
        userMenuOverlay.value?.toggle(event);
        topbarMenuActive.value = false;
    } else if (item == 'notification') {
        notification_visible.value = true;
        topbarMenuActive.value = !topbarMenuActive.value;
    } else {
        topbarMenuActive.value = !topbarMenuActive.value;
    }
};
const onChangeTheme = () => {
    useAppStore().setTheme(layoutConfig.darkTheme.value ? 'light' : 'dark');
};
const topbarMenuClasses = computed(() => {
    return {
        'layout-topbar-menu-mobile-active': topbarMenuActive.value
    };
});

const bindOutsideClickListener = () => {
    if (!outsideClickListener.value) {
        outsideClickListener.value = (event) => {
            if (isOutsideClicked(event)) {
                topbarMenuActive.value = false;
                notification_visible.value = false;
            }
        };
        document.addEventListener('click', outsideClickListener.value);
    }
};
const unbindOutsideClickListener = () => {
    if (outsideClickListener.value) {
        document.removeEventListener('click', outsideClickListener);
        outsideClickListener.value = null;
    }
};
const isOutsideClicked = (event) => {
    if (!topbarMenuActive.value) return;

    const sidebarEl = document.querySelector('.layout-topbar-menu');
    const topbarEl = document.querySelector('.layout-topbar-menu-button');
    if (sidebarEl) {
        return !(sidebarEl.isSameNode(event.target) || sidebarEl.contains(event.target) || topbarEl.isSameNode(event.target) || topbarEl.contains(event.target));
    }
    return false;
};
const closeUserMenu = () => {
    userMenuOverlay.value?.hide();
};
</script>

<template>
    <div class="layout-topbar">
        <router-link to="/" class="layout-topbar-logo">
            <img :src="logoUrl" alt="logo" />
        </router-link>

        <button class="p-link layout-menu-button layout-topbar-button" @click="onMenuToggle()">
            <i class="pi pi-bars"></i>
        </button>

        <button class="p-link layout-topbar-menu-button layout-topbar-button" @click="onTopBarMenuButton()">
            <i class="pi pi-ellipsis-v"></i>
        </button>

        <div class="layout-topbar-menu" :class="topbarMenuClasses">
            <!-- <button @click="onTopBarMenuButton('notification')" class="p-link layout-topbar-button">
                <i v-badge="2" class="pi pi-bell"></i>
                <span>Notifications</span>
            </button> -->
            <Chip class="py-0 pl-0 pr-3" v-if="UserService.user_data?.userInfo?.impersonating">
                <span class="bg-primary border-circle w-2rem h-2rem flex align-items-center justify-content-center">{{ UserService.user_data.userInfo.name?.charAt(0).toUpperCase() }}</span>
                <span class="ml-2 font-small"
                    >You are impersonating <b>{{ UserService.user_data.userInfo.name }}</b></span
                >
            </Chip>
            <button @click="onChangeTheme()" class="p-link layout-topbar-button">
                <i :class="'pi pi-' + themeIcon"></i>
                <span>Change Theme</span>
            </button>
            <button @click="(e) => onTopBarMenuButton(e, 'profile')" class="p-link layout-topbar-button" aria-haspopup="true" aria-controls="user-menu-overlay">
                <i class="pi pi-user"></i>
                <span>Profile</span>
            </button>
        </div>
    </div>

    <!-- User Menu Overlay -->
    <OverlayPanel ref="userMenuOverlay" id="user-menu-overlay" appendTo="body" :dismissable="true">
        <UserMenu @close="closeUserMenu" />
    </OverlayPanel>

    <!-- <Notification v-if="notification_visible" /> -->
</template>
